import {
  type ManagedByAutoneToggleState,
  type MatchSystemRecommendationToggleState,
} from '../old/storage/session-storage';

export const managedByAutoneToBoolean = (state: ManagedByAutoneToggleState) => {
  switch (state) {
    case 'autone':
      return true;
    case 'you':
      return false;
    case 'off':
    default:
      return null;
  }
};

export const matchSystemRecommendationToBoolean = (
  state: MatchSystemRecommendationToggleState,
) => {
  switch (state) {
    case 'yes':
      return true;
    case 'no':
      return false;
    case 'off':
    default:
      return null;
  }
};
